import { useContext } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import AuthContext from '../../context/authContext';
import { Box } from '@mui/material';
import EditableList from '../EditableList/EditableList';
import { viewRootTextPrimarySx } from '../../util/chartTheme';
import { Button } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';

function MailTemplateManagement() {
  const authCtx = useContext(AuthContext);
  const navigate = useNavigate();

  if (!authCtx.checkRight('mailTemplate:read')) {
    return <Navigate to='/welcome' replace />;
  }

  const schema = {
    key: {
      label: 'Schlüssel',
      type: 'text',
      required: true,
      minWidth: '180px',
    },
    description: {
      label: 'Beschreibung',
      type: 'text',
      required: false,
      minWidth: '240px',
      previewInList: true,
      previewMaxLines: 2,
    },
    entertainmentId: {
      label: 'Entertainment',
      type: 'select',
      api: {
        fieldName: 'entertainment',
        itemField: 'entertainmentId',
        idName: '_id',
        resource: 'entertainment',
        labelField: 'longName',
        valueField: '_id',
        skipSpecial: true,
      },
      required: false,
      placeholder: 'Entertainment auswählen',
      minWidth: '220px',
    },
    subject: {
      label: 'Betreff',
      type: 'text',
      required: true,
      minWidth: '240px',
    },
  };

  return (
    <Box sx={viewRootTextPrimarySx}>
    <EditableList
      schema={schema}
      title='Neues Mail-Template anlegen'
      resourceType='mailTemplate'
      headerSearchPlaceholder='Mail Templates durchsuchen'
      parentIsEditable={authCtx.checkRight('mailTemplate:update')}
      options={{ titleKey: 'key' }}
      renderRowActions={item => (
        <Button
          size='small'
          variant='outlined'
          startIcon={<EditIcon />}
          onClick={() => navigate(`/mailTemplateEditor?templateId=${item._id}`)}
          sx={{ textTransform: 'none' }}
        >
          Texte bearbeiten
        </Button>
      )}
      visibleColumnKeys={['key', 'description', 'entertainmentId', 'subject']}
    />
    </Box>
  );
}

export default MailTemplateManagement;
